module.exports = __webpack_public_path__ + "static/img/lisa.adce1aec.png";